export enum RevisionStatus {
    PathwaySelection = 'Pathway selection',
    TherapiesAndTrials = 'Therapies & trials',
    ReportReview = 'Report review',
    WORKFLOW_STATUS ='Updated event successfully'
}